// export const RQ_USER_LOGIN_API = {
//   url: 'api/v1/user/login',
//   method: 'POST',
//   auth: false,
// };

export const RQ_USER_LOGIN_API = {
  url: 'auth/login',
  method: 'POST',
  auth: false,
};

export const RQ_USER_FORGOT_PASSWORD_API = {
  url: 'api/v1/user/forgot/password',
  method: 'PUT',
  auth: false,
};

export const RQ_FACEBOOK_USER_LOGIN_API = {
  url: 'oauth2/authorization/facebook',
  method: 'GET',
  auth: false,
};
